import { padding, margin } from '@10d/tend-ui-styling';
import Flex from 'antd-core/es/flex';
import styled from 'styled-components';

const Root = styled(Flex) `
  ${padding};
  ${margin};
`;

export { Root };
//# sourceMappingURL=styled.js.map
